import {injectIntl} from "react-intl";
import Column from "@amzn/meridian/column";
import React from "react";
import Icon from "@amzn/meridian/icon";
import downloadSmallTokens from "@amzn/meridian-tokens/base/icon/download-small";
import Button from "@amzn/meridian/button";
import {createDownloadableFile, generateFileName} from "../util/Util";
import {EMPTY_STRING, EVENT_TYPE} from "../util/Constants";
import {MHELogsCSVParser} from "../util/Parsers";

const DownloadFile = (props) => {
    const {downloadButtonName, eventType, data, deviceType, prefix} = props;

    const downloadFile = () => {
        const fileName = generateFileName(prefix)
        const result = getParsedData()
        createDownloadableFile(fileName, result)
    }

    const getParsedData = () => {
        if (eventType === EVENT_TYPE.MHE_LOG_DATA) {
            return MHELogsCSVParser.STRINGIFY(props.intl, data, deviceType);
        } else {
            return EMPTY_STRING;
        }
    }

    return (
        <Column>
            <Button size="small" onClick={() => {downloadFile()}}>
                <Icon tokens={downloadSmallTokens} />
                {downloadButtonName}
            </Button>
        </Column>
    )
}


export default injectIntl(DownloadFile)


// WEBPACK FOOTER //
// ./src/components/commonui/DownloadFile.js